import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../myComponents/Menu';
import './SetupPlatformPage.css';
import Footer from '../myComponents/Footer';

const SetupIOSPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="App">
      <div style={{ position: 'relative', zIndex: 1000 }}>
        <Menu />
      </div>
      
      <section className="platform-setup-section">
        <div className="platform-container">
          {/* Header */}
          <div className="platform-header">
            <div className="platform-breadcrumb">
              <Link to="/setup">
                ← Все инструкции
              </Link>
            </div>
            <h1 className="platform-title">Как установить VPN на iOS/MacOS</h1>
            <p className="platform-description">
              RED BUTTON предлагает несколько способов для подключения к VPN на iPhone и iPad. <br/><br/>
              Вы можете выбрать любое приложении из списка ниже, они все бесплатные и практически не отличаются друг от другая. Мы Рекомендуем приложение Happ
            </p>
          </div>

          {/* App Tabs */}
          <div className="app-tabs">
            <div 
              className={`tab ${activeTab === 0 ? 'active' : ''}`}
              onClick={() => setActiveTab(0)}
            >
              ⚡ Happ
            </div>
            <div 
              className={`tab ${activeTab === 1 ? 'active' : ''}`}
              onClick={() => setActiveTab(1)}
            >
              Hiddify
            </div>
            <div 
              className={`tab ${activeTab === 2 ? 'active' : ''}`}
              onClick={() => setActiveTab(2)}
            >
              V2Box
            </div>
          </div>

          {/* Setup Steps */}
          <div className="setup-steps">
            
            {/* Happ Tab */}
            {activeTab === 0 && (
              <>
                <div className="tab-text-content">
                  <p>Для настройки RedButton на устройствах iOS (iPhone, iPad) вам потребуется приложение Happ и ключ доступа. Рекомендуем использовать именно приложение Happ.</p>
                  
                  <h1>⚡ Установка Happ</h1>
                  <p>Скачайте и установите бесплатное приложение Happ Plus из App Store.</p>
                  
                  <div className="section-button">
                    <a href="https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Happ для региона РФ
                        </button>
                    </a>
                  </div>
                  <div className="section-button">
                    <a href="https://apps.apple.com/us/app/happ-proxy-utility/id6504287215" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Happ для всех регионов
                        </button>
                    </a>
                  </div>
                  
                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Susbscription link, который прислал Telegram-бот.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, что бы ее скопировать</li>
                        <li>Вы так же можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Подключение VPN</h1>
                  <p>Откройте Happ. Нажмите кнопку Из Буфера, чтобы импортировать конфигурацию. Разрешите вставку. Выберите локацию и запустите подключение. Разрешите подключение</p>
                  <p>Готово! Теперь вы подключены к быстрому и надежному VPN. ⚡</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>Скриншот приложения</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Вы можете воспользовать кнопкой 'clipboard' 'вставить из буфера'</li>
                        <li>Либо нажать на '+' в правом верхнем углу и выбрать subscription-ссылку или QR код</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/happ_import.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Hiddify Tab */}
            {activeTab === 1 && (
              <>
                <div className="tab-text-content">
                  <p>Hiddify - современное и мощное приложение с открытым исходным кодом для всех популярных протоколов VPN.</p>
                  <p>Процесс установки не отличим от других</p>
                  
                  <h1>Установка Hiddify</h1>
                  <p>Скачайте и установите бесплатное приложение Hiddify из App Store.</p>
                  
                  <div className="section-button">
                    <a href="https://apps.apple.com/app/hiddify-next/id6596777532" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Скачать Hiddify
                        </button>
                    </a>
                  </div>
                  
                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Susbscription link, который прислал Telegram-бот.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, что бы ее скопировать</li>
                        <li>Вы так же можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Запуск Hiddify</h1>
                  <p>Выберите свою страну в настройках. При выборе региона “Россия” доступ ко всем .RU и .РФ сайтам, сервисам VK и Yandex будет “напрямую”(без VPN). Поэтому для проверки локации не используйте 2ip.ru, а используйте whoer.net. Если вы хотите, чтобы подключение до всех адресов шло через VPN — выберите в качестве страны "Другой"<br/><br/>

Если у вас возникают проблемы с подключением, то необходимо: Перейти во вкладку Параметры конфигурации или Настройки, в разделе "DNS" установить Cloudflare (1.1.1.1) или Google DNS (8.8.8.8) для обхода блокировок провайдера.</p>
                  <p>Готово! Hiddify обеспечивает стабильное и быстрое соединение. 🔒</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>Скриншот приложения</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Откройте приложение Hiddify</li>
                        <li>Нажмите на '+' для добавления профиля</li>
                        <li>Выберите 'Добавить из буфера обмена'</li>
                        <li>Вставьте вашу subscription-ссылку</li>
                        <li>Нажмите 'Добавить' для сохранения</li>
                        <li>Выберите сервер из списка</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/hiddify.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* V2Box Tab */}
            {activeTab === 2 && (
              <>
                <div className="tab-text-content">
                  <p>V2Box - мощный клиент для работы с протоколами V2Ray/Xray с продвинутыми настройками.</p>
                  
                  <h1>Установка V2Box</h1>
                  <p>Скачайте и установите приложение V2Box из App Store.</p>
                  <p>Приложение не доступно в российском App Store, поэтому потребуется сменить регион.</p>
                  
                  <div className="section-button">
                    <a href="https://apps.apple.com/app/v2box-v2ray-client/id6446814690" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Скачать V2Box
                        </button>
                    </a>
                  </div>
                  
                  <h1>Первоначальная настройка</h1>
                  <p>V2Box предоставляет расширенные возможности настройки для опытных пользователей.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, что бы ее скопировать</li>
                        <li>Вы так же можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Подключение и настройки</h1>
                  <p>Выберите сервер из списка и активируйте соединение. V2Box позволяет тонко настроить параметры подключения.</p>
                  <p>Профессиональный инструмент для максимальной производительности. 🚀</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>Расширенные настройки</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Перейдите во вклдаку config</li>
                        <li>Нажмите на '+' для добавления профиля</li>
                        <li>Выберите 'Добавить из буфера обмена'</li>
                        <li>Вставьте вашу subscription-ссылку</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/v2box.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SetupIOSPage;